import { Component } from "@angular/core";

@Component({ standalone: false,

    templateUrl: "./unauthorized-access.html"
})
export class UnAuthorizedAccessComponent{


}


